import React from 'react'
import { Box } from '@chatterbug/aaron'

const HorizontalDivider = () => {
  // width={1} becomes fat for some reason
  return <Box width="100%" height="1px" mt="3x" mb="2x" bg="gray88"></Box>
}

export default HorizontalDivider
